import React from "react";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { useStyles } from "./Styles";
import AppMenu from "./AppMenu";
import Loading from "../../../shared/Loading";

const propTypes = {
  children: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
  cprs: PropTypes.array.isRequired,
  completed: PropTypes.array.isRequired,
  notifications: PropTypes.array.isRequired,
  supportMessage: PropTypes.array.isRequired,
  messages: PropTypes.array.isRequired,
  old: PropTypes.array.isRequired,
  fetchCprs: PropTypes.func.isRequired,
  count: PropTypes.number.isRequired,
  messagesCount: PropTypes.number.isRequired,
};

Layout.prototype = propTypes;

export default function Layout(props) {
  const styles = useStyles();
  React.useEffect(() => {}, [props.notifications, props.messages, props.cprs, props.page]);
  return (
    <Box id="patient-portal-container">
      {props.loading ? (
        <Loading message="loading" />
      ) : (
        <AppMenu {...props} className={styles.appMenu}>
          {props.children}
        </AppMenu>
      )}
    </Box>
  );
}
